import { merge } from "lodash";
import { ComponentsOverrides as CommonComponentsOverrides } from "../../common";

/**
 * Generates component overrides for the theme.
 * @param {object} theme - The theme object.
 * @returns {object} - The merged component overrides.
 */
/**
 * Component overrides for theme
 * @param theme - Material-UI theme object
 * @returns Theme component overrides configuration
 */
export const ComponentsOverrides = (theme: any): any => {
  return merge(
    CommonComponentsOverrides(theme),
    // Alert(theme),
    // AppBar(theme),
    // Button(theme),
    // Chip(theme),
    // InputLabel(theme),
    // OutlinedInput(theme)
  );
};
